import React, { memo, useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import {
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  Menu,
  MenuItem,
  IconButton,
  Icon,
} from "investira.react.components";
import { dates, formats } from "investira.sdk";
import { HighchartsReact } from "investira.react.charts";
import { validators } from "investira.sdk";
import services from "../../../../services";

const AtivoPatrimonio = memo((props) => {
  const { pessoa } = props;

  console.log("pessoa", pessoa);

  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const xOptions = useMemo(() => {
    const TODAY = new Date();
    const DATA_FIM = dates.toSqlDate(dates.toSqlDate(TODAY));
    const DATA_INICIO = dates.toSqlDate(
      dates.addYears(dates.toSqlDate(TODAY), -10)
    );

    const xResult = {
      key: "pl",
      request: services.pessoas.pl,
      params: {
        data_inicio: DATA_INICIO,
        data_fim: DATA_FIM,
        pessoa_id: props.pessoa.pessoa_id,
        sort: "data ASC",
        consolidacao_tipo: 1,
      },
      formatData: (pData) => {
        return pData.map((xPoint) => {
          const xDate = dates
            .startOf("month", dates.toDate(xPoint.data))
            .getTime();
          return [xDate, xPoint.pl];
        });
      },
      options: {
        title: {
          text:
            pessoa?.setor_id === "65.41.3.00"
              ? "Patrimônio Social"
              : "Patrimônio líquido",
        },
        tooltip: {
          formatter: function (tooltip) {
            const xDate = formats.formatDateCustom(this.point.x, "MMM/YYYY");
            const xValue = formats.friendlyNumber(this.point.y, 2, false);
            const xFullValue = formats.formatNumber(
              this.point.y,
              2,
              true,
              false
            );

            return `
              <span style="font-size: 1em"><b>${xDate}</b></span><br/>
              <span style="color:${this.color}">\u25CF</span>
              ${this.series.name}: <b>${xValue}</b> (${xFullValue})<br/>
              `;
          },
        },
        yAxis: {
          type: "linear",
          title: {
            text:
              pessoa?.setor_id === "65.41.3.00"
                ? `Patrimônio social (R$)`
                : `Patrimônio líquido (R$)`,
          },
        },
        xAxis: {
          type: "datetime",
          crosshair: true,
        },
        series: [
          {
            name: pessoa?.setor_id === "65.41.3.00" ? "PS" : "PL",
            type: "line",
            data: data,
            zones: [
              {
                value: 0, // Up to zero
                color: "#ed442c", // Color for values above zero
              },
              {
                color: "#00dfa8", // Color for values below zero
              },
            ],
          },
        ],
      },
    };

    return xResult;
  }, [data, pessoa]);

  useEffect(() => {
    console.log(xOptions);
    setLoading(true);
    props.pessoa.pessoa_id &&
      xOptions.request({ ...xOptions.params, data: null }, (rRes) => {
        const xData = xOptions.formatData(rRes.data);

        setData(xData);
        setLoading(false);
      });
  }, [props.pessoa.pessoa_id]);

  // Render

  return <HighchartsReact key="pl" options={xOptions} />;

  //return <div>NHE</div>;
});

AtivoPatrimonio.propTypes = {};

export default AtivoPatrimonio;
